<template>
    <div id="separation-element-settings">
        <div class="form-field">
            <label for="line-color" class="form-label">Çizgi Rengi</label>
            <input
                type="color"
                id="line-color"
                class="form-input"
                v-model="item.separationElement.separationColor"
                @input="setSeparationColor(item.separationElement.separationColor)"
            >
            <small class="form-description">Ayırma elemanının rengini seçin veya girin (örn. #RRGGBB)</small>
        </div>

<!--        <div class="form-field">-->
<!--            <label for="element-style" class="form-label">Ayırma Elemanı Stili</label>-->
<!--            <select-->
<!--                id="element-style"-->
<!--                class="form-select"-->
<!--                v-model="separatorStyle"-->
<!--                @input="setSeparatorStyle(separatorStyle)"-->
<!--            >-->
<!--                <option value="solid">Düz</option>-->
<!--                <option value="dotted">Kesik Çizgi</option>-->
<!--                &lt;!&ndash; Diğer seçenekler burada yer alabilir &ndash;&gt;-->
<!--            </select>-->
<!--            <small class="form-description">Ayırma elemanınız için bir stil seçin</small>-->
<!--        </div>-->

        <div class="form-field">
            <label for="element-height" class="form-label">Ayırma Elemanı Yüksekliği</label>
            <input
                type="number"
                id="element-height"
                class="form-input"
                v-model="item.separationElement.separatorHeight"
                @input="setSeparatorHeight(item.separationElement.separatorHeight)"
            >
            <small class="form-description">Ayırma elemanının yüksekliğini girin</small>
        </div>

        <div class="form-field">
            <label for="bottom-margin" class="form-label">Altındaki Boşluk</label>
            <input
                type="number"
                id="bottom-margin"
                class="form-input"
                v-model="item.separationElement.separatorBottom"
                @input="setSeparatorBottom(item.separationElement.separatorBottom)"
            >
            <small class="form-description">Ayırma elemanının altına boşluk ekleyin</small>
        </div>

        <div class="form-field">
            <label for="top-margin" class="form-label">Üstündeki Boşluk</label>
            <input
                type="number"
                id="top-margin"
                class="form-input"
                v-model="item.separationElement.separatorTop"
                @input="setSeparatorTop(item.separationElement.separatorTop)"
            >
            <small class="form-description">Ayırma elemanının üstüne boşluk ekleyin</small>
        </div>

        <div class="form-field">
            <label for="side-margin" class="form-label">Yan Boşluk</label>
            <input
                type="number"
                id="side-margin"
                class="form-input"
                v-model="item.separationElement.separatorSide"
                @input="setSeparatorSide(item.separationElement.separatorSide)"

            >
            <small class="form-description">Ayırma elemanının sağına ve soluna boşluk ekleyin</small>
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SeparationElementSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            separationColor: this.item.separationElement.separationColor,
            separatorStyle: this.item.separationElement.separatorStyle,
            separatorHeight: this.item.separationElement.separatorHeight,
            separatorBottom: this.item.separationElement.separatorBottom,
            separatorTop: this.item.separationElement.separatorTop,
            separatorSide: this.item.separationElement.separatorSide,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        duplicateField() {
            console.log("Alan kopyalandı");
        },
        setSeparationColor(color) {
            if (color.startsWith("#") && color.length === 7) {
                this.separationColor = color;
                this.$emit("update-separation-color", color);
                this.updateFields();
            } else {
                console.error("Invalid color format. Please use #RRGGBB format.");
            }
        },
        setSeparatorStyle(style) {
            this.separatorStyle = "solid";
            this.$emit("update-separator-style", style);
            this.updateFields();
        },
        setSeparatorHeight(height) {
            this.separatorHeight = height;
            this.$emit("update-separator-height", height);
            this.updateFields();
        },
        setSeparatorBottom(bottom) {
            this.separatorBottom = bottom;
            this.$emit("update-separator-bottom", bottom);
            this.updateFields();
        },
        setSeparatorTop(top) {
            this.separatorTop = top;
            this.$emit("update-separator-top", top);
            this.updateFields();
        },
        setSeparatorSide(side) {
            this.separatorSide = side;
            this.$emit("update-separator-side", side);
            this.updateFields();
        },
        updateFields() {
            const updateFields = {
                separationElement: {
                    separationColor: this.separationColor,
                    separatorStyle: this.separatorStyle,
                    separatorHeight: this.separatorHeight,
                    separatorBottom: this.separatorBottom,
                    separatorTop: this.separatorTop,
                    separatorSide: this.separatorSide,
                },
            };
            console.log("Updating Separation Element with", updateFields, "for formId", this.item.formId, "and fieldId", this.item.id);
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields,
            });
        },
    },
};
</script>

<style scoped lang="scss">
#separation-element-settings {
    padding: 15px;
    background-color: #ffffff;
    color: #333333;
    border-radius: 8px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .form-label {
            margin-bottom: 5px;
            font-weight: bold;
            color: #333;
        }

        .form-input, .form-select {
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            background-color: #f9f9f9;
            color: #333;
            font-size: 16px;
            width: 200px;
        }

        .form-description {
            margin-top: 5px;
            font-size: 12px;
            color: #666;
        }

        .duplicate-button {
            padding: 10px;
            border: none;
            border-radius: 4px;
            background-color: #e0e0e0;
            color: #333;
            font-size: 14px;
            cursor: pointer;
            width: fit-content;

            &:hover {
                background-color: #d0d0d0;
            }
        }
    }
}
</style>
